import React, { useEffect, useState } from "react"

import { FaTwitter, FaInstagram, FaLinkedin } from "react-icons/fa"

// Gatsby
import { useStaticQuery, graphql, navigate } from "gatsby"
import Img from "gatsby-image"

// Styles
import styles from './styles.module.css'

// Libs
import slugify from 'slugify'

const Doctors = () => {
  const [doctors, setDoctors] = useState()

  const data = useStaticQuery(graphql`
    query GetDoctors {
      doctors: allStrapiDoctor {
        nodes {
          email
          name
          twitter
          instagram
          linkedin
          specialization
          image {
            childImageSharp {
              fluid {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
      }
    }
  `)

  useEffect(() => {
    if (data && data.doctors) {
      setDoctors(data.doctors.nodes.map(d => ({ ...d, image: d.image.childImageSharp.fluid })))
    }
  }, [data])

  return (
    <section className="grid grid-cols-12">
      <div className="lg:col-span-12 col-start-2 col-span-10 text-center font-base my-12">
        <h5 className="text-3xl tracking-wider">ESPECIALISTAS MÉDICOS</h5>
      </div>
      <div className="col-start-2 col-span-10">
        <div className="grid grid-cols-12">
          {doctors && (doctors.map((d, i) => (
            <div data-aos="fade-down" data-aos-duration="800" key={i} className="col-span-12 lg:col-span-3 hover:shadow-lg relative" onClick={() => navigate(`/doctors/${slugify(d.name)}`)}>
              <div className={styles.container}>
                <Img fluid={d.image} />
                <div className={styles.overlay}>
                  <a className="hover:text-teal-400 text-main_color text-xl mx-2 p-2" href={d.twitter} target="_blank" rel="noreferrer"> <FaTwitter /></a>
                  <a className="hover:text-teal-400 text-main_color text-xl mx-2 p-2" href={d.instagram} target="_blank" rel="noreferrer"> <FaInstagram /></a>
                  <a className="hover:text-teal-400 text-main_color text-xl mx-2 p-2" href={d.linkedin} target="_blank" rel="noreferrer"> <FaLinkedin /></a>
                </div>
              </div>
              <div className="p-8">
                <h3 className="text-xl font-medium">{d.name}</h3>
                <h4 className="my-4 font-thin text-sm">{d.email}</h4>
              </div>
            </div>
          )))}
        </div>
      </div>
    </section>
  )
}

export default Doctors